import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { apiErrorMessage, useAuth } from "@/AuthContext";
import { FORGOT_PASSWORD } from "@/constants/testIds/auth";
import PublicFooter from "@/components/PublicFooter";

export default function ForgotPasswordPage() {
  const { user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!loading && user) {
    return <Navigate to={user.has_access ? "/dashboard" : "/billing?subscribe=1"} replace />;
  }

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mp-auth">
      <div className="mp-auth-card">
        <p className="mp-kicker">MinutePay</p>
        <h1>Forgot password</h1>
        <p className="mp-lead">Enter the email on your MinutePay account.</p>
        {done ? (
          <p className="mp-success">
            If an account exists for that email, we sent a reset link. Check your inbox.
          </p>
        ) : (
          <form onSubmit={onSubmit} className="mp-form">
            <label>
              Email
              <Input
                data-testid={FORGOT_PASSWORD.emailInput}
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </label>
            {error ? <p className="mp-error">{error}</p> : null}
            <Button data-testid={FORGOT_PASSWORD.submitButton} type="submit" disabled={busy} className="w-full">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="mp-switch">
          <Link data-testid={FORGOT_PASSWORD.loginLink} to="/login">
            Back to sign in
          </Link>
        </p>
      </div>
      <PublicFooter />
    </div>
  );
}
